export interface ScheduleRow {
    [key: string]: string | number;
}

export interface Schedules {
    rows: ScheduleRow[];
    total: number;
}

export interface SchedulesV2 {
    monday: ScheduleRow[];
    tuesday: ScheduleRow[];
    wednesday: ScheduleRow[];
    thursday: ScheduleRow[];
    friday: ScheduleRow[];
    saturday: ScheduleRow[];
    sunday: ScheduleRow[];
}

export interface SchedulesV3 {
    [key: string]: ScheduleRow[];
}
export interface UploadScheduleDetail {
    moduleGroupId?: string;
    activeDate?: number;
    expireDate?: number;
}

export interface EntitySchedulesTab {
    status: boolean,
    message: string,
    data: Schedules
}

export interface SchedulesJobStatus {
    status: string,
    completion: number,
    result: object
}

export interface ScheduleFilterParameters {
    status?: string;
    secondary_id?: string;
}

export interface ScheduleRoutesFiltersParameters {
    secondary_id_row_id?: string;
    folder_id?: string;
}

export class SchedulesTab {
    static create (schedulesData: EntitySchedulesTab): SchedulesTab {
        const {
            status,
            message,
            data: schedules
        } = schedulesData;
        
        return new SchedulesTab(
            status,
            message,
            schedules
        );
    }
    constructor(
        public readonly status: boolean,
        public readonly message: string,
        public readonly schedules: Schedules
    ) {}
}
